import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, CheckCircle2 } from 'lucide-react';
const BUYERS = [{
  name: 'Lucas',
  city: 'Buenos Aires',
  country: 'Argentina'
}, {
  name: 'Mateo',
  city: 'Córdoba',
  country: 'Argentina'
}, {
  name: 'Florencia',
  city: 'Rosario',
  country: 'Argentina'
}, {
  name: 'Julieta',
  city: 'Mendoza',
  country: 'Argentina'
}, {
  name: 'Nicolás',
  city: 'La Plata',
  country: 'Argentina'
}, {
  name: 'Valentina',
  city: 'Tucumán',
  country: 'Argentina'
}, {
  name: 'Tomás',
  city: 'Mar del Plata',
  country: 'Argentina'
}, {
  name: 'Carolina',
  city: 'Salta',
  country: 'Argentina'
}, {
  name: 'Sebastián',
  city: 'Santa Fe',
  country: 'Argentina'
}, {
  name: 'Daniela',
  city: 'Neuquén',
  country: 'Argentina'
}, {
  name: 'Andrés',
  city: 'Bahía Blanca',
  country: 'Argentina'
}, {
  name: 'María',
  city: 'San Juan',
  country: 'Argentina'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyerIndex, setBuyerIndex] = useState(0);
  useEffect(() => {
    let interval: ReturnType<typeof setInterval>;
    const showPopup = () => {
      setBuyerIndex(Math.floor(Math.random() * BUYERS.length));
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    const initialTimeout = setTimeout(() => {
      showPopup();
      interval = setInterval(() => {
        showPopup();
      }, Math.floor(Math.random() * (25000 - 15000 + 1) + 15000));
    }, 5000);
    return () => {
      clearTimeout(initialTimeout);
      if (interval) clearInterval(interval);
    };
  }, []);
  const buyer = BUYERS[buyerIndex];
  return <AnimatePresence data-id="element-211">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-6 left-6 z-50 max-w-sm bg-white rounded-xl shadow-2xl border border-gray-100 p-4 flex items-start gap-4" data-id="element-212">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-213">
            <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-214" />
          </div>
          <div data-id="element-215">
            <p className="text-sm text-gray-800 font-medium leading-snug" data-id="element-216">
              <span className="font-bold" data-id="element-217">{buyer.name}</span> de {buyer.city},{' '}
              {buyer.country} acaba de comprar este producto.
            </p>
            <p className="text-xs text-gray-500 mt-1 flex items-center gap-1" data-id="element-218">
              <MapPin className="w-3 h-3" data-id="element-219" /> Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}